import { Button } from "@mui/material";
import {
  useContactConflictLink,
  usePendingContactConflicts,
} from "../../hooks/contact-conflicts.hook";

export function ContactConflictAction() {
  const { data } = usePendingContactConflicts();
  const { openConflict } = useContactConflictLink();
  const pending = data?.find((item) => item.status === "pending");
  if (!pending) return null;
  return (
    <Button
      color="inherit"
      fullWidth
      sx={{
        justifyContent: "flex-start",
        textTransform: "none",
        p: 1,
        whiteSpace: "nowrap",
      }}
      onClick={() => openConflict(pending.uid)}
    >
      Resolve contact conflict
    </Button>
  );
}
